import { createHook, createStore } from 'react-sweet-state';
import { PriceFinderState } from '../models';
import * as actions from './actions';

type PriceFinderActions = typeof actions;

export const initialState: PriceFinderState = {
  unitCount: 10,
  billingCycle: 'MONTHLY',
  priceCalcs: []
};

const store = createStore<PriceFinderState, PriceFinderActions>({
  name: 'bxp-price-finder',
  initialState,
  actions
});

export const usePriceFinderStore = createHook(store);
